import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faDownload } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { faEye } from "@fortawesome/free-solid-svg-icons";

import html2pdf from "html2pdf.js";
import {
  getArea_ByEventDetailsID,
  getDuttyAllotement,
  getEvent_AllottedData,
  getEventList,
} from "../../CrudOperations/GetOperation";
import {
  AddDeputyAllotementInDataBase,
  ManulaAllotement,
} from "../../CrudOperations/PostOperation";
import { useNavigate } from "react-router-dom";
import CrystalReport from "../CrystalReport/CrystalReport";
import ColorBadge from "../ColorBadge";
import ManulaAllotementModal from "./ManulaAllotementModal";

// Reusable Stat Card Component
const StatCard = ({
  title,
  subtitle,
  subSubTitle,
  colors,
  onClick,
  tag,
  isActive,
}) => (
  <div
    onClick={onClick}
    className={`relative cursor-pointer ${colors} p-5 rounded-xl shadow-md transition 
      ${isActive ? "scale-105 shadow-lg" : ""} 
      hover:scale-105 hover:shadow-lg text-white`}
  >
    {/* Corner Tag */}
    {tag && (
      <div className="absolute top-2 right-2 bg-white text-xs text-gray-800 font-semibold px-2 py-1 rounded-full shadow">
        {tag === "bg-red-500"
          ? "Past"
          : tag === "bg-green-500"
          ? "Current"
          : tag === "bg-blue-500"
          ? "Upcoming"
          : "error"}
      </div>
    )}

    <h3 className="text-xl font-semibold">{subtitle}</h3>
    <h2 className="text-md text-gray-200 font-semibold">{title}</h2>
    <h2 className="text-md text-gray-200 font-semibold">{subSubTitle}</h2>
  </div>
);

const DutyAllotementt = () => {
  const reportRef = useRef();
  const [DuttyAlloment, setDuttyAlloment] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [Loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [duttyAllotments, setDuttyAllotments] = useState([]);
  const [filteredDuttyAllotments, setFilteredDuttyAllotments] = useState([]);
  const [events, setEvents] = useState([]);
  const [Filtered_events, setFiltered_Events] = useState([]);

  const [OpenManualAllotement, setOpenManualAllotement] = useState(false);
  const [ManualAllotementData, setManualAllotementData] = useState("");

  const [areas, setAreas] = useState({
    areas: [],
    dutyAllotmentCode: "",
    isAllotted: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      const dutyRes = await getDuttyAllotement();
      if (dutyRes?.data?.Message === "Success") {
        setDuttyAllotments(dutyRes.data.AllottedDeputies);
        setFilteredDuttyAllotments(dutyRes.data.AllottedDeputies);
      }

      const eventRes = await getEventList();
      console.log(eventRes);

      if (eventRes.data?.Message === "Success") {
        setEvents(eventRes.data.Data);
        setFiltered_Events(eventRes.data.Data);
      }
    };

    fetchData();
  }, []);

  const handleSearchInput = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filtered = events.filter((d) =>
      d.EventName.toLowerCase().includes(query)
    );
    setFiltered_Events(filtered);
  };

  const handleEventClick = async (eventId) => {
    setSelectedEventId(eventId); // highlight clicked card

    const res = await getArea_ByEventDetailsID(eventId);
    console.log(res);

    if (res.data?.Message === "Success") {
      setAreas(res.data.Data);
    } else if (res.data?.ServerMessage == "No areas found for this event.") {
      setAreas({
        areas: [],
        dutyAllotmentCode: "",
        isAllotted: "",
      });

      toast.warn("Area Not Found!");
    } else {
      toast.error("Failed to fetch areas.");
    }
  };

  const handleDownload = () => {
    if (!areas.isAllotted) {
      return toast.warn("Deputies have not been allocated yet.");
    }

    const element = reportRef.current;

    html2pdf()
      .set({
        margin: 0,
        filename: "Deputy-Allottement-Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["css", "legacy"], before: "#pagebreak" },
      })
      .from(element)
      .save();
  };

  const handleDutyAllotement = async () => {
    if (!selectedEventId) {
      return toast.warn("Please Select an Event");
    }

    if (!areas.areas.length > 0) {
      return toast.warn("No area has been defined for deputy allocation.");
    }

    const AllocationResponse = await AddDeputyAllotementInDataBase(
      selectedEventId
    );

    if (
      AllocationResponse.data.ServerMessage ==
      "Cannot allot staff because geotagging time interval has not been set for this event."
    ) {
      toast.warn(
        "Cannot allot staff because geotagging time interval has not been set for this event."
      );
      setLoading(true);

      const eventDetailsName =
        events.length > 0 &&
        events.find((ele) => ele.EventDetailId == selectedEventId);

      setTimeout(() => {
        navigate(`/${localStorage.getItem("token")}/geo-tag`);

        toast.warn(
          <span>
            Please set geotagging time here for{" "}
            <strong>{eventDetailsName.EventName}</strong>
          </span>
        );
        setLoading(true);
      }, 5000);
    } else if (AllocationResponse.data.Message == "Success") {
      setDuttyAlloment(AllocationResponse.data.Data);

      toast.success("Dutty Allotted Successfully!");
    }
  };

  const handleView = async () => {
    if (!selectedEventId) {
      return toast.warn("Please Select an Event");
    }

    // selectedEventId
    // if (!areas.isAllotted) {
    //   return toast.warn("Deputies have not been allocated yet.");
    // }

    const response = await getEvent_AllottedData(selectedEventId);

    if (response.data.Message == "Success") {
      navigate(`/${localStorage.getItem("token")}/view-Allotment`, {
        replace: true,
        state: { data: response.data.Data },
      });
    } else if (
      response.data.ServerMessage == "No staff allotted for this event."
    ) {
      toast.warn(response.data.ServerMessage);
    }
  };

  const handleManulAllotement = () => {
    if (!selectedEventId) {
      toast.warn("Please Select Event!!!");
      return;
    }

    setOpenManualAllotement(true);
    setManualAllotementData(selectedEventId);
    // const response = await ManulaAllotement();
  };

  const handleManualOnSubmit = () => {
    toast.warn("......");
  };

  const getEventStatusClass = (startDate, endDate) => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const start = new Date(startDate);
    const end = new Date(endDate);

    if (end < today) return "bg-red-500"; // Past
    if (start >= today && start < tomorrow) return "bg-green-500"; // Today
    if (start >= tomorrow) return "bg-blue-500"; // Upcoming
    return "";
  };

  if (Loading)
    return (
      <div className="flex justify-center items-center h-full">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );

  return (
    <div className=" p-6 md:p-10 bg-white rounded-lg shadow-lg">
      <h1 className="text-2xl font-bold text-gray-800 mb-6 border-b-4 border-blue-600 pb-2">
        Duty Allotment Dashboard
      </h1>

      {/* Action Bar */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
        <input
          type="text"
          placeholder="Search by Event..."
          value={searchQuery}
          onChange={handleSearchInput}
          className="w-full md:w-1/2 border border-gray-300 px-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
        />
      </div>

      {/* Main Content */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Events Section */}
        <div className="bg-gray-50 p-4 rounded-md shadow">
          <div className="flex flex-row justify-between mb-3">
            <h2 className="text-lg font-semibold text-gray-700 mb-4">Events</h2>

            <div className="flex gap-4  rounded-md px-3 text-sm">
              <ColorBadge label="Current Event" status="Current_Event" />
              <ColorBadge label="Past Event" status="Past_Event" />
              <ColorBadge label="Upcoming Event" status="Comming_Event" />
              {/* <ColorBadge label="Pending Approval" status="pending" /> */}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {Filtered_events.length > 0 ? (
              Filtered_events.map((event) => (
                <StatCard
                  key={event.EventDetailId}
                  title={event.EventName}
                  colors={`border-b text-black transition-colors duration-200 ${getEventStatusClass(
                    event.StartDate,
                    event.EndDate
                  )}`}
                  onClick={() => handleEventClick(event.EventDetailId)}
                  tag={getEventStatusClass(event.StartDate, event.EndDate)}
                  isActive={selectedEventId === event.EventDetailId} // ← this line
                />
              ))
            ) : (
              <p className="text-gray-500">No events found.</p>
            )}
          </div>
        </div>

        {/* Areas Section */}
        <div className="bg-gray-50 p-4 rounded-md shadow">
          <div className="flex flex-row justify-between mb-3">
            <h2 className="text-lg font-semibold text-gray-700 mb-4">Areas</h2>

            <div className="flex gap-4  rounded-md px-3 text-sm">
              <button
                onClick={handleView}
                className={`  ${
                  areas.isAllotted
                    ? "flex items-center gap-1 text-xs py-1 px-2 rounded-md border  bg-pink-200"
                    : "flex items-center gap-1 text-xs py-1 px-2 rounded-md border cursor-not-allowed bg-pink-200 hover:bg-pink-200"
                }`}
              >
                <FontAwesomeIcon icon={faEye} />
                View
              </button>
              <button
                onClick={() => {
                  if (!areas.isAllotted) {
                    handleDutyAllotement();
                  }
                }}
                disabled={areas.isAllotted}
                className={`${
                  areas.isAllotted
                    ? "flex items-center bg-blue-200 gap-1 text-xs py-1 px-2 rounded-md border cursor-not-allowed "
                    : "flex items-center gap-1 text-xs bg-blue-200 py-1 px-2 rounded-md border hover:bg-blue-100"
                }`}
              >
                <FontAwesomeIcon icon={faPlus} />
                Auto Allotment
              </button>
              <button
                onClick={() => handleManulAllotement()}
                className={`flex items-center bg-orange-200 gap-1 text-xs py-1 px-2 rounded-md border cursor-pointer `}
              >
                <FontAwesomeIcon icon={faPlus} />
                Manual Allotment
              </button>
              {/* <button
                onClick={handleDownload}
                className={`  ${
                  areas.isAllotted
                    ? " flex items-center gap-1 text-xs py-1 px-2 rounded-md border  bg-gray-100"
                    : "flex items-center gap-1 text-xs py-1 px-2 rounded-md border cursor-not-allowed hover:bg-blue-100"
                }`}
              >
                <FontAwesomeIcon icon={faDownload} />
                Download Allotment
              </button> */}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
            {areas.areas.length > 0 ? (
              areas.areas.map((area) => (
                <StatCard
                  onClick={() =>
                    navigate(`/${localStorage.getItem("token")}/manageArea`, {
                      state: { areaId: area.AreaId },
                    })
                  }
                  key={area.AreaId}
                  title={`No. Of Deputation : ${area.NoOfDeputation}`}
                  subtitle={`${area.AreaName}, ${area.DistrictName}`}
                  subSubTitle={`Alloted Deputies : ${area.AllottedCount}`}
                  colors="bg-gradient-to-br from-green-500 to-emerald-600"
                />
              ))
            ) : (
              <p className="text-gray-500">Select Event.</p>
            )}
          </div>
        </div>
      </div>

      <div
        ref={reportRef}
        className="p-4 bg-white text-black max-w-3xl mx-auto mt-8 hidden"
      >
        <CrystalReport props={DuttyAlloment} />
      </div>

      {OpenManualAllotement && (
        <ManulaAllotementModal
          ManualAllotementData={ManualAllotementData}
          closeModal={() => setOpenManualAllotement(false)}
          onsubmit={handleManualOnSubmit}
        />
      )}

      {/* Modal Placeholder */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">Add Deputy Form</h2>
            {/* Include your modal form here */}
            <button
              onClick={() => setIsModalOpen(false)}
              className="mt-4 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DutyAllotementt;
